import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";

function SideBarDropdown({ label, url, dropdownList, icon, isOpen, onToggle }) {
   const navigate = useNavigate();
   const location = useLocation();
   const [openSubmenu, setOpenSubmenu] = React.useState("");

   const handleOpenSubmenu = (submenuName) => {
      setOpenSubmenu((prev) => (prev === submenuName ? "" : submenuName));
   };

   const openPathInNewTab = (path) => {
      window.open(
         `${window.location.origin}${path}`,
         "_blank",
         "noopener,noreferrer"
      );
   };

   const handleRouteNavigation = (event, path) => {
      if (!path) return;

      const isNewTabClick =
         event.ctrlKey || event.metaKey || event.button === 1 || event.type === "auxclick";

      if (isNewTabClick) {
         event.preventDefault();
         openPathInNewTab(path);
      } else {
         navigate(path);
      }
   };

   const handlePrimaryItemClick = (event, item) => {
      if (item.subDropdownList.length > 0) {
         if (event.type === "auxclick") return;
         handleOpenSubmenu(item.subMenuName);
         return;
      }

      handleRouteNavigation(event, `${url + item.url}`);
   };

   const isChildActive = dropdownList.some((item) => {
      const path = `${url}${item.url}`;
      if (location.pathname.startsWith(path)) return true;
      return item.subDropdownList?.some((sub) =>
         location.pathname.startsWith(`${url}${item.url}${sub.url}`)
      );
   });

   return (
      <div className={`oil-sidebar__dropdown ${isOpen ? "is-open" : ""} ${isChildActive ? "has-active" : ""}`}>
         <ListItemButton
            className={`oil-sidebar__link oil-sidebar__parent ${isOpen ? "menu-open" : ""}`}
            onClick={onToggle}
         >
            <ListItemIcon className="oil-sidebar__icon" sx={{ minWidth: 28 }}>
               <i className={`nav-icon fas ${icon}`} />
            </ListItemIcon>
            <ListItemText primary={label} className="oil-sidebar__label" />
            <ListItemIcon className="oil-sidebar__chevron" sx={{ minWidth: 16, ml: 1 }}>
               <i className={`fas ${isOpen ? "fa-angle-down" : "fa-angle-left"}`} />
            </ListItemIcon>
         </ListItemButton>

         <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding className="oil-sidebar__submenu">
               {dropdownList.map((item, index) => {
                  const itemPath = `${url}${item.url}`;
                  const itemActive =
                     location.pathname === itemPath ||
                     location.pathname.startsWith(`${itemPath}/`);
                  const nestedOpen = openSubmenu === item.subMenuName;

                  return (
                     <React.Fragment key={index.toString()}>
                        <ListItemButton
                           className={`oil-sidebar__sublink ${itemActive ? "active" : ""}`}
                           onClick={(event) => handlePrimaryItemClick(event, item)}
                           onAuxClick={(event) => handlePrimaryItemClick(event, item)}
                        >
                           <ListItemText
                              primary={item.subMenuName}
                              className="oil-sidebar__sublabel"
                           />
                           {item.subDropdownList.length > 0 && (
                              <ListItemIcon
                                 className="oil-sidebar__chevron"
                                 sx={{ minWidth: 16 }}
                              >
                                 <i
                                    className={`fas ${
                                       nestedOpen ? "fa-angle-down" : "fa-angle-left"
                                    }`}
                                 />
                              </ListItemIcon>
                           )}
                        </ListItemButton>

                        <Collapse
                           in={nestedOpen}
                           timeout="auto"
                           unmountOnExit
                        >
                           <List component="div" disablePadding className="oil-sidebar__nested">
                              {item.subDropdownList.map((itemSub, subIndex) => {
                                 const path = url + item.url + itemSub.url;
                                 const nestedActive = location.pathname.startsWith(path);
                                 return (
                                    <ListItemButton
                                       key={`${index}-${subIndex}`}
                                       className={`oil-sidebar__sublink oil-sidebar__nested-link ${
                                          nestedActive ? "active" : ""
                                       }`}
                                       onClick={(event) =>
                                          handleRouteNavigation(event, path)
                                       }
                                       onAuxClick={(event) =>
                                          handleRouteNavigation(event, path)
                                       }
                                    >
                                       <ListItemText
                                          primary={itemSub.subMenuName}
                                          className="oil-sidebar__sublabel"
                                       />
                                    </ListItemButton>
                                 );
                              })}
                           </List>
                        </Collapse>
                     </React.Fragment>
                  );
               })}
            </List>
         </Collapse>
      </div>
   );
}

export default SideBarDropdown;
